module.exports = __webpack_public_path__ + "def72c599dfc88cc2ebdc92c3c14fd81.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/feature03.png
// module id = 801
// module chunks = 3